export const ResponsiveBreakPoints = {
  MobileSm: [0, 361],
  Mobile: [0, 500],
  TabletSm: [500, 813],
  TabletLg: [813, 1081],
  Tablet: [500, 1081],
  Notebook: [1081, 1441],
  NotebookLg: [1201, 1441],
  Desktop: [1441, 1921],
  TV: [1921],
} as const;
